/**
 * Created by amu33 on 26/09/2016.
 */
import React from 'react';
import { Link } from 'react-router';
/**
 * Primary Layout
 * @returns the layout of a Primary Layout
 */
class PrimaryLayout extends React.Component {
    render() {
        return (
            <div>
                    {React.cloneElement(this.props.children, this.props)}
            </div>
        );
    }
}

export default PrimaryLayout;



/** WEBPACK FOOTER **
 ** ./app/layouts/primary/primary-layout.jsx
 **/